/**
 * 149-bt: Timezone utilities — Asia/Jakarta (WIB, UTC+7).
 *
 * PROBLEM: `new Date().toISOString().slice(0, 10)` selalu menghasilkan tanggal
 * UTC. Untuk user WIB (+7), jam ≥ 17:00 lokal = besok UTC → tanggal form
 * default meleset satu hari.
 *
 * SOLUTION: pakai `toLocaleDateString('en-CA', { timeZone })` yang mengembalikan
 * format ISO YYYY-MM-DD berdasar zona waktu tertentu. `en-CA` locale dipilih
 * karena native memakai format ISO date (nol dependensi eksternal).
 */
const JKT_TZ = "Asia/Jakarta";

/** Kembalikan tanggal hari ini (YYYY-MM-DD) di zona Asia/Jakarta. */
export function todayJKT() {
  return new Date().toLocaleDateString("en-CA", { timeZone: JKT_TZ });
}

/**
 * Ubah ISO string / Date object ke YYYY-MM-DD di Asia/Jakarta.
 * Bila input kosong / invalid, kembalikan "".
 */
export function toJKTDateString(input) {
  if (!input) return "";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-CA", { timeZone: JKT_TZ });
}

/** ISO datetime "now" — dipakai untuk API POST yang butuh timestamp. */
export function nowIso() {
  return new Date().toISOString();
}

/** Format tanggal tampilan Bahasa Indonesia — 21 Feb 2026. */
export function fmtIDDate(input) {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric", timeZone: JKT_TZ });
}
